export const paginationHandlers = {
	FIRST: 'first',
	NEXT: 'next',
	PREV: 'prev',
	LAST: 'last',
	DATACHANGE: 'dataChange',
};

export const defaultPaginationRoutePath = '/page/1';
